<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { storeToRefs } from "pinia"
import { useComparatorStore } from "@modules/courtage/stores/comparator.store"

// ================================
// REACTIVE STATE
// ================================
/**
 * Store du comparateur pour accéder aux données des sources
 */
const comparatorStore = useComparatorStore()

const { getSourceById } = storeToRefs(comparatorStore)

// ================================
// COMPUTED PROPERTIES
// ================================

/**
 * Plages horaires extraites de la source sélectionnée
 */
const getPlagesHoraires = computed(
    () =>
        getSourceById.value?.informations?.pdl?.comptage?.plages_horaires ?? {
            heures_creuses: [],
            heures_pointe_fixe: [],
            pointes: [],
        }
)
</script>

<template>
    <!-- ================================ -->
    <!-- COMPOSANT PRINCIPAL -->
    <!-- ================================ -->
    <MeterTimeline
        :heures-creuses="getPlagesHoraires.heures_creuses"
        :heures-pointes-fixes="getPlagesHoraires.heures_pointe_fixe"
        class="comparator-meter-info-offer rounded-md border border-surface-300 px-4 pt-4 pb-8"
    />
</template>
